import { keysToCamel } from "@lib/snakeTocamel"

export const parseWidgetData = (data) => {
    const widgets = data?.widgets
    let widgetData = {}
    let paymentMethods = {}
    let defaultSelectedMethodData = null
    let recommendedMethods = []
    widgets?.forEach((widget) => {
        switch (widget.type) {
            case "footnotes": {
                widgetData["footnotes"] = {
                    data: [
                        {
                            header: widget.data.header,
                            displayText: widget.data.display_text,
                        },
                    ],
                }
                break
            }
            case "payment_methods": {
                let parsedData = {
                    heading: widget.data.header,
                    bottomSheetHeading: widget.data.second_header ?? widget.data.header,
                    subHeading: widget.data.sub_header,
                    cautionMessage: widget.data.caution,
                    isSearchable: widget.data.is_search,
                    searchPlaceholder: widget.data.search_hint,
                    items: parseMethodList(
                        widget.data.items,
                        widget.data.items_to_show ?? widget.data.items?.length,
                        widget.data.type,
                        widget.data.header
                    ),
                }
                if (showAllItemsCta(parsedData)) {
                    parsedData.widgetAction = {
                        actionName: widget.data.cta?.text,
                    }
                }
                paymentMethods[widget.data.header] = parsedData
                break
            }
            case "information_with_action": {
                widgetData["infoWithAction"] = {
                    imageUrl: widget.data.image_url,
                    description: widget.data.display_text,
                    ctaLabel: widget.data.cta?.text,
                    imageVariantSmall: true,
                    allOffers: getAllOffers(widget.data.other_info?.widgets[0].data.offers),
                }
                break
            }
            case "tcp_points_details": {
                widgetData["tcpPoints"] = {
                    header: widget?.data?.redeem?.title,
                    availed: widget?.data?.redeem?.availed,
                    headerIcon: widget?.data?.redeem?.logo,
                    secondaryText: widget?.data?.redeem?.sub_title,
                    checkBoxMessage: widget?.data?.redeem?.redeemable_message,
                    redeemablePoints: widget?.data?.redeem?.redeemable_amount,
                    ...(widget?.data?.earn && {
                        earnedInfo: {
                            text: widget?.data?.earn?.earn_message_1,
                            subText: widget?.data?.earn?.earn_message_2,
                        },
                    }),
                    carePlan: {
                        user: {
                            cpUser: widget?.data?.earn?.care_plan?.cp_user ? true : false,
                            text: widget?.data?.earn?.care_plan?.cp_user
                                ? widget?.data?.earn?.care_plan?.cp_user?.text
                                : widget?.data?.earn?.care_plan?.non_cp_user?.text,
                            icon: widget?.data?.earn?.care_plan?.cp_user
                                ? widget?.data?.earn?.care_plan?.cp_user?.logo
                                : widget?.data?.earn?.care_plan?.non_cp_user?.icon,
                            functionMap: "carePlanInfoDialog",
                            infoIcon: widget?.data?.earn?.care_plan?.cp_user
                                ? null
                                : widget?.data?.earn?.care_plan?.non_cp_user?.help?.icon,
                            targetUrl: widget?.data?.earn?.care_plan?.cp_user
                                ? null
                                : widget?.data?.earn?.care_plan?.non_cp_user?.help?.target,
                        },
                        upsell: {
                            buttonType: "textual",
                            payload: {
                                skus: [
                                    {
                                        quantity:
                                            widget?.data?.earn?.care_plan?.upsell?.cta?.details?.quantity,
                                        sku_id: widget?.data?.earn?.care_plan?.upsell?.cta?.details?.sku_id,
                                    },
                                ],
                                source: "cart",
                            },
                            label: widget?.data?.earn?.care_plan?.upsell?.cta?.text,
                            responseType: "full",
                        },
                        statusInfo: {
                            text: widget?.data?.earn?.care_plan?.cp_status_info?.text,
                            icon: widget?.data?.earn?.care_plan?.cp_status_info?.icon,
                        },
                    },
                }
                break
            }
        }
    })
    const analyticsData = data.analytics_data?.info
    const shouldFetchOffer = data.apply_payment_offer
    const paymentMethod = data.widgets?.find((widget) => widget.type === "payment_methods")
    if (paymentMethod) {
        if (paymentMethod.data?.type === "RECOMMENDED_METHODS") {
            recommendedMethods = paymentMethod.data?.items?.map((item, index) => ({
                name: item.title,
                rank: index + 1,
            }))
        }

        const defaultSelectedMethod = paymentMethod?.data?.items?.find((item) => item.default_selection)
        defaultSelectedMethodData = {
            id: `${paymentMethod?.data?.type}_${defaultSelectedMethod?.type}_1`,
            payload: defaultSelectedMethod,
            analyticsData: {
                widgetName: paymentMethod?.data?.header,
                methodName: defaultSelectedMethod?.title,
                recommendationRank:
                    paymentMethod.data?.type === "RECOMMENDED_METHODS"
                        ? paymentMethod.data?.items?.indexOf(defaultSelectedMethod) + 1
                        : -1,
            },
        }
    }

    return {
        widgetData: widgetData,
        paymentMethods: paymentMethods,
        analyticsData: analyticsData,
        recommendedMethods,
        defaultSelectedMethodData,
        shouldFetchOffer,
    }
}
const getAllOffers = (data) => {
    const list = data?.map((offer) => {
        const { icon: imageUrl, header: heading, sub_header: subHeading, terms_conditions } = offer
        return {
            imageUrl,
            heading,
            subHeading,
            termsAndConditionsCta: {
                label: terms_conditions?.text,
                action: terms_conditions?.action,
            },
            applyCouponCta: { isEnabled: false, label: "" },
            couponDetails: {
                imageUrl,
                heading,
                subHeading,
            },
        }
    })

    return { list }
}
export const showAllItemsCta = (data) => {
    return data?.items?.visibleItems?.length < data?.items?.allItems?.length
}
const parseMethodList = (items, itemsToShow, widgetType, widgetName) => {
    let visibleItems = []
    let allItems = []
    let parsedData = {}
    let count = 1

    items.forEach((method, index) => {
        parsedData = {
            ...parsedData,
            rawData: method,
            widgetName: widgetName,
            methodType: method.type,
            heading: method.title,
            subHeading: method.sub_title,
            statusMessage: method.caution,
            offerMessage: method.offer,
            tncCta: method.tnc_cta,
            statusColor: method.caution ? "caution" : method.offer ? "success" : null,
            isDisabled: method.is_disabled,
            aggregator: method.aggregator,
            savedDetails: method.saved_details,
            recommendationRank: widgetType === "RECOMMENDED_METHODS" ? items.indexOf(method) + 1 : -1,
        }

        if (method.icons) {
            parsedData = {
                ...parsedData,
                type: "addNew",
                additionalPaymentMethodIcons: method.icons,
                oneClickAction: {
                    actionVariant: "empty",
                    actionType: method.cta?.action,
                },
            }
        } else {
            parsedData = {
                ...parsedData,
                activeMethodId: `${widgetType}_${method.type}_${index + 1}`,
                type: "accordion",
                paymentMethodIcon: {
                    url: method.icon,
                    altText: method.title,
                    width: "40",
                    height: "40",
                },
                accordionAction: {
                    inputPlaceholder: method.recharge_wallet_data
                        ? "Amount"
                        : method.add_card_data?.api_details
                        ? "CVV"
                        : null,
                    inputType: method.recharge_wallet_data
                        ? "text"
                        : method.add_card_data?.api_details
                        ? "password"
                        : null,
                    inputValue: method.recharge_wallet_data
                        ? `₹${method.recharge_wallet_data?.recharge_amount}`
                        : "",
                    inputMaxLength: method.add_card_data?.api_details && 4,
                    inputReadOnly: !!method.recharge_wallet_data,
                    actionName: method.cta?.text,
                    actionType: method.cta?.action,
                },
            }
        }

        if (method.link_wallet_data) {
            parsedData = {
                ...parsedData,
                linkWallet: keysToCamel(method.link_wallet_data),
            }
        }

        if (method.upi_data) {
            parsedData = {
                ...parsedData,
                upiData: keysToCamel(method.upi_data),
            }
        }

        if (method.add_card_data) {
            parsedData = {
                ...parsedData,
                cardData: keysToCamel(method.add_card_data),
            }
        }

        if (parsedData.type === "accordion") {
            if (count <= itemsToShow) {
                visibleItems.push(parsedData)
                allItems.push(parsedData)
            } else {
                allItems.push(parsedData)
            }
        } else {
            visibleItems.push(parsedData)
        }

        count = count + 1
    })

    return { visibleItems, allItems }
}
export const parseMethodsForOffer = (method, offerData, activeMethodId) => {
    let newData = { ...method }
    if (method.activeMethodId === activeMethodId) {
        if (offerData.offer_found) {
            newData.offer = offerData.offer
            newData.statusMessage = offerData.payment_method?.caution
                ? offerData.payment_method?.caution
                : offerData.payment_method?.offer
            newData.statusColor = offerData.payment_method?.caution
                ? "caution"
                : offerData.payment_method?.offer
                ? "success"
                : null

            if (method.accordionAction) {
                newData.accordionAction = {
                    ...method.accordionAction,
                    inputValue: offerData.payment_method?.recharge_wallet_data
                        ? `₹${offerData.payment_method?.recharge_wallet_data?.recharge_amount}`
                        : "",
                    actionName: offerData.payment_method?.cta?.text,
                }
            }

            if (method.linkWallet) {
                newData.linkWallet = keysToCamel(offerData.payment_method?.link_wallet_data)
            }
        }
    }

    return newData
}

export const parsePageInfoWidget = (pageInfoData) => {
    let pageInfoWidgets = {}
    if (pageInfoData?.action_button) {
        pageInfoWidgets["actionButton"] = {
            targetUrl: pageInfoData?.action_button?.target_url,
            text: pageInfoData?.action_button?.cta?.text,
        }
    }
    if (pageInfoData?.attached_prescription_data) {
        pageInfoWidgets["attachedPrescription"] = {
            listOfImages: pageInfoData.attached_prescription_data?.data?.map((item) => {
                return {
                    image: {
                        url: item.transformed_urls.small,
                        xxhighUrl: item.file_attr?.length ? item.file_attr[0].file_url : "",
                        alt: "prescription",
                        id: item.id,
                        type:
                            item.file_attr[0]?.format?.includes("pdf") ||
                            item.file_attr[0]?.format?.includes("application")
                                ? "pdf"
                                : "image",
                        cta: {
                            functionMap: "prescriptionClicked",
                        },
                        statusText: item.status,
                        documentUrl:
                            item.file_attr[0]?.format?.includes("pdf") ||
                            item.file_attr[0]?.format?.includes("application")
                                ? item.file_attr[0].file_url
                                : item.file_attr[0].file_url ||
                                  item.prescription_icon_url ||
                                  item.transformed_urls.xhigh,
                    },
                }
            }),
            header: pageInfoData.attached_prescription_data?.header,
        }
    }
    return pageInfoWidgets
}

export const parseDialogData = (data, place_order_request) => {
    if (data) {
        return {
            header: data?.header,
            description: data?.description,
            icon: data?.icon,
            primaryLabel: data?.confirm_cta?.text,
            secondaryLabel: data?.cancel_cta?.text,
            payload: {
                aggregator: place_order_request.aggregator,
                methodType: place_order_request.type,
                savedDetails: place_order_request.saved_details,
            },
        }
    } else return {}
}
